import { env } from '@/env';
import { OpenAPI } from 'services/generated/membership-service-v2/core/OpenAPI';
import { MembershipService } from 'services/generated/membership-service-v2/services/MembershipService';
import { type Membership } from 'services/generated/membership-service-v2/models/Membership';

export const getMembershipInfo = async (
  authToken: string,
): Promise<Membership | null> => {
  OpenAPI.BASE = env.NEXT_PUBLIC_MSV2_API;
  OpenAPI.HEADERS = {
    Authorization: `Bearer ${authToken}`,
  };
  try {
    const membership = await MembershipService.getMembership({});
    return membership;
  } catch (error) {
    console.error('Error getting membership info', error);
    // TODO: Log in sentry
    return null;
  }
};
